var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLocationGold = function SvgLocationGold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.625 21.25c0 14.875-19.125 27.625-19.125 27.625S6.375 36.125 6.375 21.25a19.125 19.125 0 0 1 38.25 0Z",
    fill: "#D9B310"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 27.625a6.375 6.375 0 1 0 0-12.75 6.375 6.375 0 0 0 0 12.75Z",
    fill: "#87700D"
  })));
};

export default SvgLocationGold;